module.exports = __webpack_public_path__ + "static/media/towersecurity.13387e31.png";